const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import SingleNavigation from './contestants/SingleNavigation.jsx';
import SplitContestant from './contestants/SplitContestant.jsx';

//Action to save and fetch data
import { fetchFrontSetting, frontsingleimmute, dataJudgeFetch, dataJudgeInsert } from '../actions/front_actions';

//Import Designs
import { Container, Backdrop, CircularProgress } from '@mui/material';

class Singlepagesplit extends Component {

    constructor(props) {
        super(props);
        this.state = { language: "en", listgrid: "grid", form_val: null, short: this.props.shortagrument };
    }

    componentDidMount = () => {
        this.setState({ wait: 0 })
        this.props.fetchFrontSetting(this.props.SITE_URL, this.props.shortagrument.id);

        if (typeof this.props.shortagrument !== "undefined") {
            this.setState({ listgrid: this.props.shortagrument.view });
        }

        this.setState({ wait: 1 })
    }

    handleGrid = (view) => {
        this.setState({ wait: 1 })
        this.setState({ listgrid: view });
        this.setState({ wait: 0 })
    }

    handleform = (form) => {
        this.setState({ wait: 1 })
        if (this.state.form_val == 'submit_form') {
            this.setState({ form_val: '' });
        } else {
            this.setState({ form_val: form });
        }
        this.setState({ wait: 0 })
    }

    render() {
        const shortatts = this.props.shortagrument;
        const values = this.props.model;
        const single_post = this.props.SINGLEPOST;
        let template_part = this.props.templatepart;

        if (values && (typeof single_post !== "undefined")) {
            const color = (typeof this.props.model !== null) ? this.props.model.settings.color : null;
            return (
                <Container className="wpvc_singlecontest_container">
                    {template_part == 'header' &&
                        <SingleNavigation
                            {...values}
                            {...color}
                            short={shortatts}
                            view={this.state.listgrid}
                        />
                    }
                    <SplitContestant {...values}
                        view={this.state.listgrid}
                        short={shortatts}
                        SITE_URL={this.props.SITE_URL}
                        CONSTANT={this.props.CONSTANT}
                        contestant_id={single_post}
                        templatepart={this.props.templatepart}
                    />

                    {wp.hooks.applyFilters('wpvc_single_contestant_judge', '', this.props)}

                </Container>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }
    }
}

const settingstate = state => {
    return { model: state.wpvcfrontdata };
}

export default connect(settingstate, { frontsingleimmute, fetchFrontSetting, dataJudgeFetch, dataJudgeInsert })(withTranslation("translations")(Singlepagesplit));
